import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';
import Axios from "/plugins/axios";

const styles = theme => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    width: '100%',
  },
  cssLabel: {
    '&$cssFocused': {
      color: 'rgba(0, 0, 0, 0.54)',
    },
  },
  cssFocused: {},
  cssUnderline: {
    '&:after': {
      borderBottomColor: 'rgba(0, 0, 0, 0.54)',
    },
  },
  customH6: {
    fontWeight: 'bold',
    lineHeight: 1.4,
    padding: '25px 0px 20px'
  },
  buttonRoot: {
    width: '100%',
    background: 'red',
    margin: '40px 0px',
    color: '#fff',
    '&:hover': {
        background: "red",
     },
  },

});
function Transition(props) {
    return <Slide direction="up" {...props} />;
  }
  
  class Contact extends React.Component {
   
    constructor(props) {
        super(props);
            this.state = {
                nameValue: '',
                phoneValue: '',
                emailValue: '',
                open: false,
                errorBox: false
            };
            this.handleChangeName = this.handleChangeName.bind(this);
            this.handleChangePhone = this.handleChangePhone.bind(this);
            this.handleChangeEmail = this.handleChangeEmail.bind(this);
            this.handleClose = this.handleClose.bind(this);
            this.handleSubmit = this.handleSubmit.bind(this);

    }

    handleChangeName(event) {
        this.setState({
          nameValue: event.target.value,
        });
    }
    handleChangePhone(event) {
        this.setState({
            phoneValue: event.target.value,
        });
    }
    handleChangeEmail(event) {
        this.setState({
            emailValue: event.target.value,
        });
    }
     
    handleClose = () => {
      this.setState({ open: false, errorBox: false });
    };
    handleSubmit(event) {
        Axios.post(`/contact/${this.props.brandSlug}/send`, {
          name:  this.state.nameValue,
          phone: this.state.phoneValue,
          email: this.state.emailValue,
        })
        .then((response) => {
          this.setState({
           open: true,
           nameValue: '',
           phoneValue: '',
           emailValue: ''
        })
        })
        .catch((error) => {
            this.setState({
                errorBox: true
            })
        });
        event.preventDefault();
      }

    render(){  
        const { classes, brandSlug } = this.props;
        const { nameValue, phoneValue, emailValue } = this.state;
        return (
            <div className={classes.root}>
                <Grid container spacing={24}
                    direction="row"
                    justify="center"
                    alignItems="center">
                    <Grid item xs={10} md={6}>
                        <Typography variant="h6" classes={{h6: classes.customH6}} gutterBottom align="center">
                            Please complete the fields, we will contact you shortly.
                        </Typography>
                        <form className={classes.container} autoComplete="off" onSubmit={this.handleSubmit}>
                            <TextField
                                required
                                type="name"
                                label="Name"
                                className={classes.textField}
                                margin="normal"
                                InputProps={{
                                    classes:{
                                        underline: classes.cssUnderline,
                                    }
                                }}
                                InputLabelProps={{
                                    classes:{
                                        root: classes.cssLabel,
                                        focused: classes.cssFocused,
                                    }
                                }}
                               value={nameValue}
                               onChange={this.handleChangeName}
                            />
                            <TextField
                                required
                                type="number"
                                label="Phone number"
                                className={classes.textField}
                                margin="normal"
                                InputProps={{
                                    classes:{
                                        underline: classes.cssUnderline,
                                    }
                                }}
                                InputLabelProps={{
                                    classes:{
                                        root: classes.cssLabel,
                                        focused: classes.cssFocused,
                                    }
                                }}
                                value={phoneValue}
                                onChange={this.handleChangePhone}
                            />
                            <TextField
                                required
                                type="email"
                                label="Email"
                                className={classes.textField}
                                margin="normal"
                                InputProps={{
                                    classes:{
                                        underline: classes.cssUnderline,
                                    }
                                }}
                                InputLabelProps={{
                                    classes:{
                                        root: classes.cssLabel,
                                        focused: classes.cssFocused,
                                    }
                                }}
                                value={emailValue}
                                onChange={this.handleChangeEmail}
                            />
                          
                            <Button variant="contained" type='submit' classes={{root: classes.buttonRoot,}} onSubmit={this.handleSubmit} >
                                Get Started
                            </Button>
                        </form>
                        <Dialog
                            open={this.state.open}
                            TransitionComponent={Transition}
                            keepMounted
                            onClose={this.handleClose}
                            aria-labelledby="alert-dialog-slide-title"
                            aria-describedby="alert-dialog-slide-description"
                            >
                            <DialogTitle id="alert-dialog-slide-title" style={{ textAlign: 'center' }}>
                                {"Thank you for contact us.We will contact you shortly."}
                            </DialogTitle>
                        </Dialog>
                        <Dialog
                            open={this.state.errorBox}
                            TransitionComponent={Transition}
                            keepMounted
                            onClose={this.handleClose}
                            aria-labelledby="alert-dialog-slide-title"
                            aria-describedby="alert-dialog-slide-description"
                            >
                            <DialogTitle id="alert-dialog-slide-title" style={{ textAlign: 'center' }}>
                                {"Please try again."}
                            </DialogTitle>
                            
                        </Dialog>
                    </Grid>
                </Grid>
            </div>
        )
    }
}

Contact.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Contact);
